import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";
import { resetDefaultMfRecommendationsData } from "../../utils/mf/functions";

const MODULE_PREFIX = "[ MF ]";

const Actions = {
  resetMfRecommendations: `${MODULE_PREFIX} resetMfRecommendations`,
  resetRecommendationsDefaultData: `${MODULE_PREFIX} resetRecommendationsDefaultData`,
  updateMfRecommendations: `${MODULE_PREFIX} updateMfRecommendations`,
  fetchMfRecommendations: `${MODULE_PREFIX} fetchMfRecommendations`,
  setSelectedNfoFund: `${MODULE_PREFIX} setSelectedNfoFund`,
  updateNfoFundsList: `${MODULE_PREFIX} updateNfoFundsList`,
  updateInvestmentData: `${MODULE_PREFIX} updateInvestmentData`,
  fetchMfPaymentData: `${MODULE_PREFIX} fetchMfPaymentData`,
  fetchNfoFundsList: `${MODULE_PREFIX} fetchNfoFundsList`,
  fetchNfoFundDetails: `${MODULE_PREFIX} fetchNfoFundDetails`,
};

//actions
export const resetMfRecommendations = createAction(
  Actions.resetMfRecommendations
);

export const updateMfRecommendations = createAction(
  Actions.updateMfRecommendations
);

export const resetRecommendationsDefaultData = createAction(
  Actions.resetRecommendationsDefaultData
);

export const fetchMfRecommendations = createAction(
  Actions.fetchMfRecommendations
);

export const setSelectedNfoFund = createAction(Actions.setSelectedNfoFund);

export const updateNfoFundsList = createAction(Actions.updateNfoFundsList);

export const updateInvestmentData = createAction(Actions.updateInvestmentData);

export const fetchMfPaymentData = createAction(Actions.fetchMfPaymentData);

export const fetchNfoFundsList = createAction(Actions.fetchNfoFundsList);

export const fetchNfoFundDetails = createAction(Actions.fetchNfoFundDetails);

//selectors
export const getMfRecommendations = (state) => {
  const recommendations = get(state, "mfV2.recommendations", {});
  return recommendations;
};

export const getSelectedNfoFunds = (state) => {
  const selectedNfoFunds = get(state, "mfV2.selectedNfoFunds", []);
  return selectedNfoFunds;
};

export const getNfoFundsList = (state) => {
  const fundsList = get(state, "mfV2.nfoFundsList", []);
  return fundsList;
};

export const getInvestmentData = (state) => {
  const investmentData = get(state, "mfV2.investmentData", {});
  return investmentData;
};

const initialState = {
  recommendations: {},
  selectedNfoFunds: [],
  nfoFundsList: [],
  investmentData: {},
};

//reducer
export default createReducer(initialState, (builder) => {
  builder
    .addCase(resetMfRecommendations, (state, action) => {
      state.recommendations = action.payload;
    })
    .addCase(updateMfRecommendations, (state, action) => {
      state.recommendations = { ...state.recommendations, ...action.payload };
    })
    .addCase(resetRecommendationsDefaultData, (state, action) => {
      state.recommendations = resetDefaultMfRecommendationsData(state.recommendations);
    })
    .addCase(updateNfoFundsList, (state, action) => {
      state.nfoFundsList = action.payload;
    })
    .addCase(setSelectedNfoFund, (state, action) => {
      state.selectedNfoFunds = action.payload;
    })
    .addCase(updateInvestmentData, (state, action) => {
      state.investmentData = action.payload;
    });
});
